import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import UserEditor from "../user-editor";

const CreateUser = () => {
  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neuen Benutzer erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <UserEditor />
      </div>
    </div>
  );
};

export default CreateUser;
